import { c as _c } from "react/compiler-runtime";
import { IcoCheck16, IcoClose16, IcoPencil16 } from '@onefootprint/icons';
import { CopyButton, Hint, IconButton, TextInput, Tooltip } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
const TestIdInput = () => {
  const $ = _c(47);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "sandboxOutcome"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const [idInputLocked, setIdInputLocked] = useState(true);
  const {
    register,
    formState: t1,
    resetField,
    getValues
  } = useFormContext();
  const {
    errors
  } = t1;
  let t2;
  if ($[1] !== errors.testID || $[2] !== idInputLocked || $[3] !== t) {
    t2 = () => {
      if (errors?.testID?.type === "required") {
        return t(_temp);
      }
      if (errors?.testID) {
        return t(_temp2);
      }
      if (idInputLocked) {
        return t(_temp3);
      }
      return t(_temp4);
    };
    $[1] = errors.testID;
    $[2] = idInputLocked;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getHint = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIdInputLocked(_temp5);
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleSaveOrEdit = t3;
  let t4;
  if ($[6] !== resetField) {
    t4 = () => {
      resetField("testID");
      handleSaveOrEdit();
    };
    $[6] = resetField;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleReset = t4;
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp6);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <label htmlFor="testID"><span className="text-label-2 text-primary">{t5}</span></label>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = !!errors.testID;
  let t8;
  if ($[12] !== t) {
    t8 = t(_temp7);
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = !idInputLocked;
  let t10;
  if ($[14] !== idInputLocked || $[15] !== t9) {
    t10 = cx({
      "text-quaternary": idInputLocked,
      "text-primary": t9
    });
    $[14] = idInputLocked;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== register || $[18] !== t) {
    let t12;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = /^[A-Za-z0-9_]+$/;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    t11 = register("testID", {
      required: {
        value: true,
        message: t(_temp8)
      },
      pattern: {
        value: t12,
        message: t(_temp9)
      }
    });
    $[17] = register;
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[21] !== idInputLocked || $[22] !== t10 || $[23] !== t11 || $[24] !== t7 || $[25] !== t8) {
    t12 = <TextInput id="testID" hasError={t7} placeholder={t8} testID="test-id-input" size="compact" className={t10} disabled={idInputLocked} {...t11} />;
    $[21] = idInputLocked;
    $[22] = t10;
    $[23] = t11;
    $[24] = t7;
    $[25] = t8;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== errors.testID || $[28] !== getValues || $[29] !== handleReset || $[30] !== idInputLocked || $[31] !== t) {
    t13 = idInputLocked ? <div className="flex"><CopyButton size="compact" ariaLabel={t(_temp10)} contentToCopy={getValues("testID")} tooltip={{
        position: "top",
        text: t(_temp11),
        textConfirmation: t(_temp12)
      }} /><Tooltip disabled={!t(_temp13)} content={t(_temp14)}><IconButton aria-label={t(_temp15)} onClick={handleSaveOrEdit} size="compact" icon={IcoPencil16} /></Tooltip></div> : <div className="flex"><Tooltip disabled={!t(_temp16)} content={t(_temp17)}><IconButton aria-label={t(_temp18)} onClick={handleSaveOrEdit} disabled={!!errors?.testID} icon={IcoCheck16} /></Tooltip><Tooltip disabled={!t(_temp19)} content={t(_temp20)}><IconButton aria-label={t(_temp21)} onClick={handleReset} size="compact" icon={IcoClose16} /></Tooltip></div>;
    $[27] = errors.testID;
    $[28] = getValues;
    $[29] = handleReset;
    $[30] = idInputLocked;
    $[31] = t;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t12 || $[34] !== t13) {
    t14 = <div className="flex gap-2">{t12}{t13}</div>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t14 || $[37] !== t6) {
    t15 = <div className="flex justify-between items-center">{t6}{t14}</div>;
    $[36] = t14;
    $[37] = t6;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  const t16 = !!errors?.testID;
  let t17;
  if ($[39] !== getHint) {
    t17 = getHint();
    $[39] = getHint;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t16 || $[42] !== t17) {
    t18 = <Hint hasError={t16}>{t17}</Hint>;
    $[41] = t16;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t15 || $[45] !== t18) {
    t19 = <>{t15}{t18}</>;
    $[44] = t15;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  return t19;
};
export default TestIdInput;
function _temp($) {
  return $["test-id"].errors.required;
}
function _temp2($_0) {
  return $_0["test-id"].errors.invalid;
}
function _temp3($_1) {
  return $_1["test-id"].description;
}
function _temp4($_2) {
  return $_2["test-id"].hint;
}
function _temp5(prev) {
  return !prev;
}
function _temp6($_3) {
  return $_3["test-id"].label;
}
function _temp7($_4) {
  return $_4["test-id"].placeholder;
}
function _temp8($_5) {
  return $_5["test-id"].errors.required;
}
function _temp9($_6) {
  return $_6["test-id"].errors.invalid;
}
function _temp10($_7) {
  return $_7["test-id"].button.copy;
}
function _temp11($_8) {
  return $_8["test-id"].button.copy;
}
function _temp12($_9) {
  return $_9["test-id"].button["copy-confirmation"];
}
function _temp13($_10) {
  return $_10["test-id"].button.edit;
}
function _temp14($_11) {
  return $_11["test-id"].button.edit;
}
function _temp15($_12) {
  return $_12["test-id"].button.edit;
}
function _temp16($_13) {
  return $_13["test-id"].button.save;
}
function _temp17($_14) {
  return $_14["test-id"].button.save;
}
function _temp18($_15) {
  return $_15["test-id"].button.save;
}
function _temp19($_16) {
  return $_16["test-id"].button.reset;
}
function _temp20($_17) {
  return $_17["test-id"].button.reset;
}
function _temp21($_18) {
  return $_18["test-id"].button.reset;
}